// Auto-generated by scratchpad_split.mjs during the i18n module split.
export const CONTENT = {
  fr: {
    "typology.description_activite": "Description / Activité",
    "typology.chiffres_interpretation": "Chiffres + interprétation",
    "typology.investissements": "Tableau structuré (LoB / CIC / Bilan / Capital)",
    "typology.gouvernance": "Gouvernance & schémas organisationnels",
    "typology.competences": "Liste référentielle (personnes / sous-traitants / produits)",
    "typology.gestion_risques": "Système de gestion des risques + ORSA",
    "typology.valorisation_s2": "Méthodologie / Valorisation S2",
    "typology.capital": "Gestion du capital + Constat de respect",
    "typology.synthese": "Synthèse exécutive & faits marquants",
    "typology.profil_risque": "Profil de risque (par module SCR)",
    "typology.annexe_qrt": "Néant / Mention de non-applicabilité",
    "typology.contexte_externe": "Contexte économique et réglementaire",
    "typology.fallback": "Typologie",
    "state.noExcerpt": "Extrait source non renseigne dans la capture.",
    "blockTitle.Synthèse": "Synthèse",
    "blockTitle.A": "Activité et résultats",
    "blockTitle.A.1": "Activité",
    "blockTitle.A.2": "Résultats de souscription",
    "blockTitle.A.3": "Résultats des investissements",
    "blockTitle.A.4": "Résultats des autres activités",
    "blockTitle.A.5": "Autres informations",
    "blockTitle.B": "Système de gouvernance",
    "blockTitle.B.1": "Informations générales sur le système de gouvernance",
    "blockTitle.B.2": "Exigences de compétence et d'honorabilité",
    "blockTitle.B.3": "Système de gestion des risques, y compris l'ORSA",
    "blockTitle.B.4": "Système de contrôle interne",
    "blockTitle.B.5": "Fonction d'audit interne",
    "blockTitle.B.6": "Fonction actuarielle",
    "blockTitle.B.7": "Sous-traitance",
    "blockTitle.B.8": "Autres informations",
    "blockTitle.C": "Profil de risque",
    "blockTitle.C.1": "Risque de souscription",
    "blockTitle.C.2": "Risque de marché",
    "blockTitle.C.3": "Risque de crédit",
    "blockTitle.C.4": "Risque de liquidité",
    "blockTitle.C.5": "Risque opérationnel",
    "blockTitle.C.6": "Autres risques importants",
    "blockTitle.C.7": "Autres informations",
    "blockTitle.D": "Valorisation à des fins de solvabilité",
    "blockTitle.D.1": "Actifs",
    "blockTitle.D.2": "Provisions techniques",
    "blockTitle.D.3": "Autres passifs",
    "blockTitle.D.4": "Méthodes de valorisation alternatives",
    "blockTitle.D.5": "Autres informations",
    "blockTitle.E": "Gestion du capital",
    "blockTitle.E.1": "Fonds propres",
    "blockTitle.E.2": "Capital de solvabilité requis et minimum de capital requis",
    "blockTitle.E.3": "Utilisation du sous-module « risque sur actions » fondé sur la durée",
    "blockTitle.E.4": "Différences entre la formule standard et tout modèle interne utilisé",
    "blockTitle.E.5": "Non-respect du minimum de capital requis et non-respect du capital de solvabilité requis",
    "blockTitle.E.6": "Autres informations",
    "typologyDesc.description_activite": "Bloc descriptif (forme juridique, périmètre d'activité, autorité de contrôle, audit, CAC). Faible variation N vs N-1.",
    "typologyDesc.valorisation_s2": "Description des méthodes techniques (Best Estimate, marge de risque, courbe taux EIOPA, méthodes de valorisation actifs/passifs). Faible variation N/N-1, mais signal fort si changement.",
    "typologyDesc.chiffres_interpretation": "Reporting de chiffres N/N-1 issus de plusieurs sources (RSR détaillé, QRT, comptes), avec calcul du % d'évolution et interprétation sourcée des variations. Typologie principale du SFCR.",
    "typologyDesc.investissements": "Tableaux normés Solvabilité 2 (S.05.01 par LoB, S.02.01 bilan, S.23.01 fonds propres, ventilation CIC). Pure agrégation depuis les sources QRT/RSR avec vérification de cohérence inter-cellules.",
    "typologyDesc.synthese": "Synthèse stratégique du rapport et faits marquants de l'année. Composé en dernier, dépend de tous les autres blocs validés. Sign-off DG obligatoire.",
    "typologyDesc.competences": "Listes structurées : composition CA, comités, dirigeants effectifs, sous-traitants, commissaires aux comptes, LoBs. Détection delta entrées/sorties N vs N-1.",
    "typologyDesc.profil_risque": "Pour chaque module de risque (souscription, marché, crédit, liquidité, opérationnel) : structure imposée en 4 sous-zones (description / mesure / atténuation / sensibilité). Source : RSR détaillé + rapport ORSA.",
    "typologyDesc.gestion_risques": "Description du SGR, intégration organisationnelle, processus ORSA (fréquence, périmètre, validation). Mention systématique de l'appétence au risque et du rapport ORSA approuvé.",
    "typologyDesc.annexe_qrt": "Sections déclarées « Néant » ou non applicables (pas de modèle interne, pas de méthode alternative, pas de non-respect MCR/SCR…). Vérifier qu'il n'y a vraiment rien à signaler.",
    "typologyDesc.capital": "Structure des fonds propres (par tier), SCR/MCR, ratio de couverture, et constat de respect permanent des exigences réglementaires.",
    "typologyDesc.gouvernance": "Description de la structure de gouvernance avec organigrammes, comités, fonctions clés. Inclut les schémas visuels (organigramme, processus ORSA, matrices RACI).",
    "typologyDesc.contexte_externe": "Marché de l'assurance, contexte macro, évolutions réglementaires (DORA, CSRD, EIOPA). Sources publiques uniquement. Typologie présente dans les rapports de grands groupes mais absente du SFCR EAM 2025.",
    "articleTitle.art-292": "Synthèse",
    "articleSummary.art-292": "Synthèse claire et concise du SFCR.",
    "articleTitle.art-293": "Activité",
    "articleSummary.art-293": "Description de l'activité, normes, formes juridiques.",
    "articleTitle.art-294": "Résultats de souscription",
    "articleSummary.art-294": "Informations qualitatives et quantitatives sur les résultats.",
    "articleTitle.art-295": "Résultats des investissements",
    "articleSummary.art-295": "Revenus et dépenses par catégorie d'actif.",
    "articleTitle.art-296": "Autres activités",
    "articleSummary.art-296": "Description des autres revenus et dépenses.",
    "articleTitle.art-297": "Système de gouvernance",
    "articleSummary.art-297": "Description générale du système de gouvernance.",
    "articleTitle.art-298": "Compétence et honorabilité",
    "articleSummary.art-298": "Politique d'évaluation.",
    "articleTitle.art-299": "Gestion des risques + ORSA",
    "articleSummary.art-299": "Description du SGR.",
    "articleTitle.art-300": "Contrôle interne",
    "articleSummary.art-300": "CI et conformité.",
    "articleTitle.art-302": "Profil de risque",
    "articleSummary.art-302": "Pour chaque module : description, mesure, atténuation, sensibilité.",
    "articleTitle.art-308": "Valorisation des actifs",
    "articleSummary.art-308": "Méthodes de valorisation pour chaque catégorie d'actif.",
    "articleTitle.art-308b": "Provisions techniques S2",
    "articleSummary.art-308b": "Calcul du Best Estimate + marge pour risque.",
    "articleTitle.art-310": "Fonds propres",
    "articleSummary.art-310": "Structure par tier + qualité.",
    "articleTitle.art-311": "SCR et MCR",
    "articleSummary.art-311": "SCR par module, MCR, ratio.",
    "articleTitle.art-309": "Modèle interne",
    "articleSummary.art-309": "Description du modèle interne.",
    "agentRole.agent-architecte": "Lit le SFCR N-1 et en extrait l'arborescence pour proposer le plan du SFCR N.",
    "agentRole.agent-extracteur": "Le SFCR est du reporting pur — l'Extracteur récupère les chiffres depuis les sources (RSR détaillé, QRT, ORSA, fonction actuarielle…) et calcule les % d'évolution N vs N-1. Pas d'autres calculs.",
    "agentRole.agent-interprete": "Cherche dans la KB pourquoi un chiffre a varié — produit une explication sourcée. Si rien dans la KB → escalade contributeur.",
    "agentRole.agent-economiste": "Récupère contexte externe (marché, macro, réglementaire) depuis sources publiques.",
    "agentRole.agent-redacteur": "Rédige le texte final dans le ton « Solvabilité 2 », respect du style N-1.",
    "agentRole.agent-style-keeper": "Recadre longueur, structure, choix de tableaux par rapport à N-1/N-2.",
    "agentRole.agent-auditeur-coherence": "Produit le fichier de revue de cohérence.",
    "agentRole.agent-auditeur-regl": "Produit le fichier OK/KO par article du règlement délégué.",
    "agentRole.agent-routeur": "Reformule la demande et envoie au contributeur via deep-link.",
    "agentRole.agent-manager": "Supervise l'ensemble, gère les dépendances entre blocs.",
    "personRole.p-rn": "Manager du rapport",
    "personRole.p-mr": "Co-manager",
    "personRole.p-ld": "Responsable suivi sinistralité",
    "personRole.p-cv": "Responsable provisionnement",
    "personRole.p-jm": "CRO",
    "personRole.p-sm": "DG",
    "personRole.p-pl": "Asset Management",
    "personRole.p-ad": "DRH",
    "orgUnit.Direction technique": "Direction technique",
    "orgUnit.Direction financière": "Direction financière",
    "orgUnit.Direction générale": "Direction générale",
    "orgUnit.Gestion des risques": "Gestion des risques",
    "orgUnit.Sinistres": "Sinistres",
    "orgUnit.Provisionnement": "Provisionnement",
    "orgUnit.RH": "RH",
    "orgUnit.Fonction actuarielle": "Fonction actuarielle",
    "orgUnit.Reporting réglementaire": "Reporting réglementaire",
    "docCategory.rapport_n1": "Rapport N-1",
    "docCategory.qrt": "QRT",
    "docCategory.orsa": "ORSA",
    "docCategory.fonction_actuarielle": "Fonction actuarielle",
    "docCategory.provisionnement": "Provisionnement",
    "docCategory.sinistralite": "Sinistralité",
    "docCategory.gouvernance": "Gouvernance",
    "docCategory.comptes_annuels": "Comptes annuels",
    "docStatus.indexed": "Indexé",
    "docStatus.needs_ocr": "OCR requis",
    "docCategory.autre": "Autre",
  },
  en: {
    "typology.description_activite": "Description / Activity",
    "typology.chiffres_interpretation": "Figures + commentary",
    "typology.investissements": "Structured table (LoB / CIC / Balance sheet / Capital)",
    "typology.gouvernance": "Governance & organizational charts",
    "typology.competences": "Reference list (people / vendors / products)",
    "typology.gestion_risques": "Risk management system + ORSA",
    "typology.valorisation_s2": "Methodology / Solvency II valuation",
    "typology.capital": "Capital management + compliance statement",
    "typology.synthese": "Executive summary & key events",
    "typology.profil_risque": "Risk profile (by SCR module)",
    "typology.annexe_qrt": "None / Not-applicable statement",
    "typology.contexte_externe": "Economic and regulatory context",
    "typology.fallback": "Typology",
    "state.noExcerpt": "No source excerpt recorded in the capture.",
    "blockTitle.Synthèse": "Summary",
    "blockTitle.A": "Business and performance",
    "blockTitle.A.1": "Business",
    "blockTitle.A.2": "Underwriting performance",
    "blockTitle.A.3": "Investment performance",
    "blockTitle.A.4": "Performance of other activities",
    "blockTitle.A.5": "Other information",
    "blockTitle.B": "System of governance",
    "blockTitle.B.1": "General information on the system of governance",
    "blockTitle.B.2": "Fit and proper requirements",
    "blockTitle.B.3": "Risk management system including the ORSA",
    "blockTitle.B.4": "Internal control system",
    "blockTitle.B.5": "Internal audit function",
    "blockTitle.B.6": "Actuarial function",
    "blockTitle.B.7": "Outsourcing",
    "blockTitle.B.8": "Other information",
    "blockTitle.C": "Risk profile",
    "blockTitle.C.1": "Underwriting risk",
    "blockTitle.C.2": "Market risk",
    "blockTitle.C.3": "Credit risk",
    "blockTitle.C.4": "Liquidity risk",
    "blockTitle.C.5": "Operational risk",
    "blockTitle.C.6": "Other material risks",
    "blockTitle.C.7": "Other information",
    "blockTitle.D": "Valuation for solvency purposes",
    "blockTitle.D.1": "Assets",
    "blockTitle.D.2": "Technical provisions",
    "blockTitle.D.3": "Other liabilities",
    "blockTitle.D.4": "Alternative valuation methods",
    "blockTitle.D.5": "Other information",
    "blockTitle.E": "Capital management",
    "blockTitle.E.1": "Own funds",
    "blockTitle.E.2": "Solvency Capital Requirement and Minimum Capital Requirement",
    "blockTitle.E.3": "Use of the duration-based equity risk sub-module",
    "blockTitle.E.4": "Differences between the standard formula and any internal model used",
    "blockTitle.E.5": "Non-compliance with the Minimum Capital Requirement and non-compliance with the Solvency Capital Requirement",
    "blockTitle.E.6": "Other information",
    "typologyDesc.description_activite": "Descriptive block (legal form, scope of activity, supervisory authority, audit, statutory auditors). Low year-on-year variation.",
    "typologyDesc.valorisation_s2": "Description of technical methods (Best Estimate, risk margin, EIOPA risk-free curve, asset/liability valuation methods). Low year-on-year variation, but a strong signal when it changes.",
    "typologyDesc.chiffres_interpretation": "Reporting of N/N-1 figures from multiple sources (detailed RSR, QRT, accounts), with the % change calculated and a sourced explanation of the variations. The main SFCR typology.",
    "typologyDesc.investissements": "Standardized Solvency II tables (S.05.01 by LoB, S.02.01 balance sheet, S.23.01 own funds, CIC breakdown). Pure aggregation from QRT/RSR sources with cross-cell consistency checks.",
    "typologyDesc.synthese": "Strategic summary of the report and key events of the year. Written last, depends on every other validated block. Mandatory CEO sign-off.",
    "typologyDesc.competences": "Structured lists: board composition, committees, effective managers, vendors, statutory auditors, LoBs. Detects entries/exits between N and N-1.",
    "typologyDesc.profil_risque": "For each risk module (underwriting, market, credit, liquidity, operational): a mandatory 4-part structure (description / measurement / mitigation / sensitivity). Source: detailed RSR + ORSA report.",
    "typologyDesc.gestion_risques": "Description of the risk management system, organizational integration, ORSA process (frequency, scope, approval). Systematic mention of risk appetite and the approved ORSA report.",
    "typologyDesc.annexe_qrt": "Sections declared \"None\" or not applicable (no internal model, no alternative method, no MCR/SCR breach…). Verify there is genuinely nothing to report.",
    "typologyDesc.capital": "Own-funds structure (by tier), SCR/MCR, coverage ratio, and a statement of ongoing compliance with regulatory requirements.",
    "typologyDesc.gouvernance": "Description of the governance structure with org charts, committees, key functions. Includes visual diagrams (org chart, ORSA process, RACI matrices).",
    "typologyDesc.contexte_externe": "Insurance market, macro context, regulatory developments (DORA, CSRD, EIOPA). Public sources only. Present in large groups' reports but absent from the EAM 2025 SFCR.",
    "articleTitle.art-292": "Summary",
    "articleSummary.art-292": "Clear and concise summary of the SFCR.",
    "articleTitle.art-293": "Business",
    "articleSummary.art-293": "Description of the business, standards, legal forms.",
    "articleTitle.art-294": "Underwriting performance",
    "articleSummary.art-294": "Qualitative and quantitative information on performance.",
    "articleTitle.art-295": "Investment performance",
    "articleSummary.art-295": "Income and expenses by asset category.",
    "articleTitle.art-296": "Other activities",
    "articleSummary.art-296": "Description of other income and expenses.",
    "articleTitle.art-297": "System of governance",
    "articleSummary.art-297": "General description of the system of governance.",
    "articleTitle.art-298": "Fit and proper requirements",
    "articleSummary.art-298": "Assessment policy.",
    "articleTitle.art-299": "Risk management + ORSA",
    "articleSummary.art-299": "Description of the risk management system.",
    "articleTitle.art-300": "Internal control",
    "articleSummary.art-300": "Internal control and compliance.",
    "articleTitle.art-302": "Risk profile",
    "articleSummary.art-302": "For each module: description, measurement, mitigation, sensitivity.",
    "articleTitle.art-308": "Valuation of assets",
    "articleSummary.art-308": "Valuation methods for each asset category.",
    "articleTitle.art-308b": "Solvency II technical provisions",
    "articleSummary.art-308b": "Best Estimate calculation + risk margin.",
    "articleTitle.art-310": "Own funds",
    "articleSummary.art-310": "Structure by tier + quality.",
    "articleTitle.art-311": "SCR and MCR",
    "articleSummary.art-311": "SCR by module, MCR, ratio.",
    "articleTitle.art-309": "Internal model",
    "articleSummary.art-309": "Description of the internal model.",
    "agentRole.agent-architecte": "Reads the N-1 SFCR and extracts its outline to propose the N SFCR plan.",
    "agentRole.agent-extracteur": "The SFCR is pure reporting — the Extractor pulls figures from the sources (detailed RSR, QRT, ORSA, actuarial function…) and computes the % change vs N-1. No other calculations.",
    "agentRole.agent-interprete": "Searches the KB for why a figure changed — produces a sourced explanation. If nothing is in the KB → escalates to a contributor.",
    "agentRole.agent-economiste": "Gathers external context (market, macro, regulatory) from public sources.",
    "agentRole.agent-redacteur": "Writes the final text in the \"Solvency II\" tone, respecting the N-1 style.",
    "agentRole.agent-style-keeper": "Reframes length, structure, and table choices against N-1/N-2.",
    "agentRole.agent-auditeur-coherence": "Produces the consistency review file.",
    "agentRole.agent-auditeur-regl": "Produces the OK/KO file per article of the delegated regulation.",
    "agentRole.agent-routeur": "Rephrases the request and sends it to the contributor via a deep link.",
    "agentRole.agent-manager": "Oversees the whole pipeline, manages dependencies between blocks.",
    "personRole.p-rn": "Report manager",
    "personRole.p-mr": "Co-manager",
    "personRole.p-ld": "Claims monitoring lead",
    "personRole.p-cv": "Reserving lead",
    "personRole.p-jm": "CRO",
    "personRole.p-sm": "CEO",
    "personRole.p-pl": "Asset Management",
    "personRole.p-ad": "HR Director",
    "orgUnit.Direction technique": "Technical department",
    "orgUnit.Direction financière": "Finance department",
    "orgUnit.Direction générale": "Executive management",
    "orgUnit.Gestion des risques": "Risk management",
    "orgUnit.Sinistres": "Claims",
    "orgUnit.Provisionnement": "Reserving",
    "orgUnit.RH": "HR",
    "orgUnit.Fonction actuarielle": "Actuarial function",
    "orgUnit.Reporting réglementaire": "Regulatory reporting",
    "docCategory.rapport_n1": "N-1 report",
    "docCategory.qrt": "QRT",
    "docCategory.orsa": "ORSA",
    "docCategory.fonction_actuarielle": "Actuarial function",
    "docCategory.provisionnement": "Reserving",
    "docCategory.sinistralite": "Claims experience",
    "docCategory.gouvernance": "Governance",
    "docCategory.comptes_annuels": "Annual accounts",
    "docStatus.indexed": "Indexed",
    "docStatus.needs_ocr": "OCR required",
    "docCategory.autre": "Other",
  },
};
